import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { PlanCreationDialogComponent } from './plan-creation-dialog.component';

@NgModule({
  declarations: [PlanCreationDialogComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    DialogContainerModule,
  ],
})
export class PlanCreationDialogModule {}
